import * as React from "react";
import type { SVGProps } from "react";
const SvgSizeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      stroke="#05B2AE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m8.929 27.314-4.95-4.95c-.424-.424-.424-.99 0-1.414L20.95 3.98c.425-.425.99-.425 1.415 0l5.657 5.656c.424.424.424.99 0 1.414L12.464 26.607m2.829-11.314-2.828-2.829m8.485-2.828L18.12 6.808m-1.414 4.242-1.414-1.414m-4.243 7.071-1.414-1.414"
    />
    <path
      fill="#05B2AE"
      d="M10.343 23.071a1 1 0 1 0-1.414-1.414 1 1 0 0 0 1.414 1.414"
    />
  </svg>
);
export default SvgSizeIcon;
